<template>
    <Main>
        <div slot="main" class="main archives">
            <div class="bank_title">
                <Header :data='headerInfo' style="background-color:#000a1c"></Header>
                <div class="gobcak" @click="goBack"><img src="../../assets/return.png" alt=""><span>返回</span></div>
            </div>
            <div class="content">
                <div class="left">
                    <div class="top">
                        <div class="server" style="width:6.25rem">
                            <div>
                                <span class="card_">运动量分布</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="date">
                                <span @click="serviceStatusBtn('first')"
                                    :class="{ active: serviceStatus === 'first' }">近7日</span>
                                <span @click="serviceStatusBtn('three')"
                                    :class="{ active: serviceStatus === 'three' }">近15日</span>
                                <span @click="serviceStatusBtn('six')"
                                    :class="{ active: serviceStatus === 'six' }">近30日</span>
                            </div>
                        </div>
                        <div class="sport">
                            <span>{{ data_Sport.avg || 0 }}</span>
                            <span>平均运动量</span>
                        </div>
                        <div id="lineChart" class="line_chart"></div>
                    </div>
                    <div class="bottom">
                        <div class="server" style="width:6.25rem">
                            <div>
                                <span class="card_">活畜定位</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>

                        </div>
                        <div class="video_box">
                            <div class="device_box">
                                <baidu-map class="map" :center="{ lng: 115.738250, lat: 44.614480 }" :zoom="12">
                                    <bm-navigation :enableGeolocation="true" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
                                    <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
                                        anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-map-type>
                                    <bm-marker :position="{ lng: 115.738250, lat: 44.614480 }" :dragging="true"
                                        animation="BMAP_ANIMATION_BOUNCE"
                                        :icon="{ url: animalImg, size: { width: 50, height: 50 } }">
                                    </bm-marker>
                                </baidu-map>
                            </div>
                            <div class="top_box"></div>
                        </div>
                    </div>
                </div>
                <div class="center">
                    <div class="center_top">
                        <div class="top_item">
                            <span>耳标编码</span>
                            <div class="small_big" style="width: 2.6rem;">{{ info.theEarEncipher }}
                                <div class="top_box"></div>
                            </div>
                        </div>
                        <div class="top_item">
                            <span>活畜品种</span>
                            <div class="small_big">{{ info.liveVariety }}
                                <div class="top_box"></div>
                            </div>
                        </div>
                        <div class="top_item">
                            <span>月龄</span>
                            <div class="small_big" style="width: 1.4rem;">{{ info.monthAge }}
                                <div class="top_box"></div>
                            </div>
                        </div>
                        <div class="top_item">
                            <span>出生日期</span>
                            <div class="small_big" style="width: 1.6rem;">{{ info.birth }}
                                <div class="top_box"></div>
                            </div>
                        </div>
                        <div class="top_item">
                            <span>状态</span>
                            <div class="small_big small_big_state" style="width: 1.6rem;"
                                :class="{ state: onLineState == false }">{{
                                    onLineState ? '在线' : '离线' }}
                                <div class="top_box"></div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="zhan"></div>
                        <div class="turn">
                            <div class="turn_item"></div>
                        </div>
                        <div class="animal sheep"></div>
                        <div style="left:2.58rem;top:0" class="heart">
                            <img src="../../assets/heart.png" alt="">
                            <div class="heart_r">
                                <!-- <span>{{ info.heartRate }}</span> -->
                                <span>{{ heartRate }}</span>
                                <span>当前心率</span>
                            </div>
                        </div>
                        <div style="left:6.14rem;top:0.65rem" class="heart">
                            <img src="../../assets/hot.png" alt="">
                            <div class="heart_r">
                                <!-- <span>{{ info.animalHeat == '—' ? '—' : info.animalHeat + "℃" }}</span> -->
                                <span>{{ hotAnimal + '℃' }}</span>
                                <span>当前体温</span>
                            </div>
                        </div>
                        <div style="left:7.35rem;top:3.47rem" class="heart">
                            <img src="../../assets/run.png" alt="">
                            <div class="heart_r">
                                <!-- <span class="heart_item">{{ info.liveness }}</span> -->
                                <span>{{ activeAnimal }}</span>
                                <span>活跃度</span>
                            </div>
                        </div>
                        <div style="left:0.2rem;top:4.19rem" class="heart heart_">
                            <img src="../../assets/sport.png" alt="">
                            <div class="heart_r" style="margin-left:0">
                                <!-- <span>{{ info.todayStepNumber }}</span> -->
                                <span>{{ todayStepNumber }}</span>
                                <span>今日运动量</span>
                            </div>
                        </div>
                        <div class="heart_line">
                            <div style="bottom:0;left:-0.12rem" class="big_box">
                                <div class="center_box1">
                                    <div class="small_box"></div>
                                </div>
                            </div>
                        </div>
                        <div class="tempera">
                            <div style="bottom:0;left:-0.12rem" class="big_box">
                                <div class="center_box1">
                                    <div class="small_box"></div>
                                </div>
                            </div>
                        </div>
                        <div class="rate">
                            <div style="bottom:-0.12rem;right:-0.1rem" class="big_box">
                                <div class="center_box1">
                                    <div class="small_box"></div>
                                </div>
                            </div>
                        </div>
                        <div class="active_">
                            <div style="bottom:-0.12rem;left:-0.1rem" class="big_box">
                                <div class="center_box1">
                                    <div class="small_box"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        <div @click="switchStatusBtn('0')" class="switch">
                            <img :src="imgfile[0].img" alt="" v-if="imgfile[0].show">
                            <span>{{ footerList[0] }}</span>
                        </div>
                        <div @click="switchStatusBtn('1')" class="switch">
                            <img :src="imgfile[1].img" alt="" v-if="imgfile[1].show">
                            <span>{{ footerList[1] }}</span>
                        </div>
                        <div @click="switchStatusBtn('2')" class="switch">
                            <img :src="imgfile[2].img" alt="" v-if="imgfile[2].show">
                            <span>{{ footerList[2] }}</span>
                        </div>
                        <div @click="switchStatusBtn('3')" :class="{ active1: switchStatus === footerList[3] }"
                            class="switch">
                            <img :src="imgfile[3].img" alt="" v-if="imgfile[3].show">
                            <span>{{ footerList[3] }}</span>
                        </div>
                        <div @click="switchStatusBtn('4')" class="switch">
                            <img :src="imgfile[4].img" alt="" v-if="imgfile[4].show">
                            <span>{{ footerList[4] }}</span>
                        </div>
                        <div @click="switchStatusBtn('5')" class="switch">
                            <img :src="imgfile[5].img" alt="" v-if="imgfile[5].show">
                            <span>{{ footerList[5] }}</span>
                        </div>
                        <div @click="switchStatusBtn('6')" class="switch">
                            <img :src="imgfile[6].img" alt="" v-if="imgfile[6].show">
                            <span>{{ footerList[6] }}</span>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="top">
                        <div class="server" style="width:6.25rem">
                            <div>
                                <span class="card_">体温预警</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="date">
                                <span @click="statusBtn('first_')" :class="{ active: status === 'first_' }">近7日</span>
                                <span @click="statusBtn('three_')" :class="{ active: status === 'three_' }">近15日</span>
                                <span @click="statusBtn('six_')" :class="{ active: status === 'six_' }">近30日</span>
                            </div>
                        </div>

                        <div style="display: flex;">
                            <div class="sport">
                                <span>{{ temperaItem.avg ? (temperaItem.avg + '℃') : '0' }}</span>
                                <span>平均体温</span>
                            </div>
                            <!-- <div class="sport" style="margin-left: .5rem;">
                                <span style="color: #f7ab08;">23</span>
                                <span>预警次数</span>
                            </div> -->
                        </div>
                        <div id="lineChart2" class="line_chart2"></div>
                    </div>
                    <div class="bottom">
                        <div class="server" style="width:6.25rem">
                            <div>
                                <span class="card_">电子围栏</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                        </div>
                        <div class="video_box">
                            <div class="device_box">
                                <div id="map" class="map_main"></div>
                            </div>
                            <div class="top_box"></div>
                        </div>
                    </div>
                </div>
                <div v-if="isShow" class="box_">
                    <div class="dialog" v-if="show1">
                        <span class="text">{{ text }}</span>
                        <span class="el-icon-close close_icon" @click="closeIcon"></span>
                        <div class="picture">
                            <div class="p_left">
                                <!-- <video :src='imgList[0]' id="video" v-if="show3" style="width:100%;height:3rem"></video> -->
                                <img :src='imgList[0]' v-if="show3" alt="">
                                <!-- <img :src='imgList[0]' v-else alt="">
                                        <div @click="videoshows" v-if="shows"
                                            style="text-align: center;line-height: 3rem;background-color:transparent;width:3rem;height:3rem;position: absolute;top: 1.2rem;left: .5rem;cursor: pointer;z-index: 10;">
                                            <span style="color:#FFFFFF;font-size: .38rem;" class="el-icon-video-play"></span>
                                        </div> -->
                                <!-- <div class="img">
                                            <img @click="imgBtn(1, 0)" v-if="show4" :src="imgList[1]" alt="">
                                            <div @click="imgBtn(1)" v-else style="width:100%;height:1rem"><video
                                                    :src='imgList[1]' style="width:100%;height:1rem"></video></div>
                                            <img @click="imgBtn(2, 0)" v-if="show5" :src='imgList[2]' alt="">
                                            <div @click="imgBtn(2)" v-else style="width:100%;height:1rem"><video
                                                    :src='imgList[2]' style="width:100%;height:1rem"></video></div>
                                            <img @click="imgBtn(3, 0)" v-if="show6" :src='imgList[3]' alt="">
                                            <div @click="imgBtn(3)" v-else style="width:100%;height:1rem"><video
                                                    :src='imgList[3]' style="width:100%;height:1rem"></video></div>
                                        </div> -->
                                <div class="img">
                                    <img @click="imgBtn(1)" :src="imgList[1]" alt="">
                                    <img @click="imgBtn(2)" :src='imgList[2]' alt="">
                                    <img @click="imgBtn(3)" :src='imgList[3]' alt="">
                                </div>
                            </div>
                            <div class="p_right">
                                <div class="info_1">
                                    <span v-for="(item, i) in infoList" :key="i">{{ item.name }}</span>
                                </div>
                                <div class="info_">
                                    <span v-for="(item, i) in infoList" :key="i"
                                        :style="{ color: item.value == '监管中' ? '#FF5A0E' : '#FFFFFF' }">{{
                                            item.value
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dialog_" v-if="show2">
                        <span class="text">{{ text }}</span>
                        <span class="el-icon-close close_icon" @click="closeIcon"></span>
                        <div class="table" style="margin-top: 1.2rem;">
                            <dv-scroll-board @mouseover="mouseover" :config="config" class="sheet"
                                style="width:14.9rem;min-height:3rem;padding-bottom:0.2rem;margin:auto;" />
                            <!-- <div v-if="total >= 10" class="num">
                                    共计{{ total }}条
                                    <span class="el-icon-arrow-left" @click="btnClick('left')"
                                        :class="{ num_change: numStatus === 'left' }"></span>
                                    <span class="el-icon-arrow-right" @click="btnClick('right')"
                                        :class="{ num_change: numStatus === 'right' }"></span>
                                </div> -->
                        </div>
                    </div>
                </div>
                <video src="../../assets/video_bg_1.mp4" autoplay="autoplay" loop class="fillWidth" muted='muted'>
                </video>
            </div>
        </div>
    </Main>
</template>
<script type="text/javascript" src="https://api.map.baidu.com/api?v=2.0&ak=BnKBCnnQGMGiSnEmjgRyhXZRG4MV2YuS"></script>
<script>
import Main from "@/components/main.vue";
import Header from "../../components/shanHeader.vue";
// import BMap from 'BMap'

export default {
    components: {
        Main,
        Header,
        // XChart
    },
    data() {
        return {
            isShow: false,
            show1: false,
            show2: false,
            show3:true,
            numStatus: 'right',
            headerInfo: {},
            userInfo: {},
            serviceStatus: 'first',
            status: 'first_',
            switchStatus: '活畜动态',
            footerList:['基础信息','免疫记录','检疫记录','活畜动态','称重记录','疾病治疗记录','繁育记录'],
            sheepImg:require("../../assets/sheep.png"),
            animalImg:require('../../assets/niu.jpg'),
            imgfile:[{img:require("../../assets/file1.png"),show:true},{img:require("../../assets/file2.png"),show:true},{img:require("../../assets/file3.png"),show:true},
            {img:require("../../assets/file4.png"),show:true},{img:require("../../assets/file5.png"),show:true},{img:require("../../assets/file6.png"),show:true},{img:require("../../assets/file7.png"),show:true}
        ],//左右不带下标的切换图
            imgfile_:[require("../../assets/file11.png"),require("../../assets/file22.png"),require("../../assets/file33.png"),
            require("../../assets/file44.png"),require("../../assets/file55.png"),require("../../assets/file66.png"),require("../../assets/file77.png")
        ],//左右```带下标的切换图
            // imgList:[require('../../assets/HUD_1.mp4'),require('../../assets/niu2.jpg'),require('../../assets/niu3.jpg'),require('../../assets/niu4.jpg')],
           imgList:[require('../../assets/niu1.jpg'),require('../../assets/niu2.jpg'),require('../../assets/niu3.jpg'),require('../../assets/niu4.jpg')],
           angusImgList:[require('../../assets/angus_niu1.png'),require('../../assets/angus_niu2.png'),require('../../assets/angus_niu3.png'),require('../../assets/angus_niu4.png')],
            text:'基础信息',
            anType: '',
            path: [],
            info:{},
            config : {},
            infoList: [],
            exerciseDisMap:{},//存储运动量分布
            lineData:[],
            data_Sport: {},//存储运动
            temperatureDisMap:{},//体温
            temperaItem:{},//单个体温
            temperaData:[],
            liveStockLocation:[],
               //  页码
            pageNum: 1,//第几页
            pageSize: 10,//一页几条
            total: 0,//总数
            hasPreviousPage: false,//上一页
            hasNextPage: false,//下一页
            // tableData: [],
            // 存储免疫记录数据
            immuneRecordData: [],
            // 存储治病记录数据
            diseaseRecordData: [],
            // 存储体重记录数据
            weightRecordData: [],
            // 存储繁育记录数据
            breedRecordData: [],
            // 存储检疫记录数据
            quarantineData:[],
            result:{},
            lang:[3,20,0,0],
            shows:true,
            show4:true,
            show5:true,
            show6:true,
            activeAnimal:'懒惰',
            heartRate:65,//心率
            hotAnimal:'-',//体温,
			todayStepNumber:'-',//今日运动量
            onLineState:false,
        };
    },
    watch: {},
    created() {
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        this.info = JSON.parse(window.localStorage.getItem('MYANIMALINFO'))
        for(var key in this.info){
            if(!this.info[key]){
                this.info[key]='—'
            }
        }
        this.infoList= [
            { name: '耳标编码：', value: this.info.theEarEncipher },
            { name: '活畜类别：', value: this.info.liveVariety },
            // { name: '监管状态：', value: this.info.superviseStatus },
            { name: '出生日期：', value: this.info.birth },
            { name: '月 龄：', value: this.info.monthAge },
            { name: '父亲编号：', value: this.info.fatherNumber },
            { name: '父亲编号类型：', value: this.info.fatherNumberType },
            { name: '母亲编号：', value: this.info.motherNumber },
            { name: '母亲编号类型：', value: this.info.motherNumberType },
            ]
            this.heartRate=this.random(60,70)
            // this.hotAnimal=(38 + Math.random()*(39.5 - 38)).toFixed(1)

    },
    mounted() {
        // 获取在线离线
        this.getOnLine()
        // 获取运动量及体温
        this.getAnimalInfo()
        this.getassemblyList()
        this.enclosureList()
       if(this.$route.query.farmerName=="火山牧业"){
        this.imgList=this.angusImgList
       }
        if(this.info.categoryName=="羊"){
        document.querySelector('.center_box .sheep').style.backgroundImage=`url(${this.sheepImg})`;
        document.querySelector('.center_box .sheep').style.backgroundPosition=`0rem 0rem`;
        document.querySelector('.center_box .animal').style.width=6+`rem`;
        document.querySelector('.center_box .animal').style.height=5+`rem`;
        document.querySelector('.center_box .animal').style.top=.7+`rem`;
        document.querySelector('.center_box .animal').style.left=.85+`rem`;
        document.querySelector('.center_box .tempera').style.height=1.8+`rem`;
        document.querySelector('.center_box .heart_line').style.height=1.64+`rem`;
        this.animalImg=require('../../assets/jump_sheep.png')
        }
    },
    update(){

    },
    methods: {
        random(min,max){
         return  Math.floor( min + Math.random()*(max - min))
        },
        getOnLine(){
            if(!this.info.maleEarTagNo||this.info.maleEarTagNo=="—"){
                return
            }
            this.$http({
                url:'screenapp-service/common/isOnline',
                method: 'post',
                data: {
                    "iccid":this.info.maleEarTagNo
                },
            }).then(res => {
                 const data = res.data;
                 if(data.msg=="token不存在或已过期，请重试！"||data.code==500){
                    this.onLineState=false
                    return
                 }
                    if(data.code === 200) {
                       this.onLineState=data.result
                    } else {
                    // this.$message.error(data.message);
                }
            })
        },
        getAnimalInfo(){
            if(!this.info.maleEarTagNo||this.info.maleEarTagNo=="—"){
                return
            }
            // console.log(this.info,'6');
            this.$http({
                url:'screenapp-service/screenLiveStock/selectLivestockTempByTagNum',
                method: 'post',
                data: {
                    "maleEarTagNo":this.info.maleEarTagNo
                },
            }).then(res => {
                 const data = res.data;
                    if(data.code === 200) {
                        this.hotAnimal=data.result.temp
                //         this.todayStepNumber= data.result.step
                //    if(this.todayStepNumber<=6000){
			    //      this.activeAnimal='懒惰'
			    //    } else if(this.todayStepNumber>=9000){
			    //      this.activeAnimal='活跃'
			    //    } else {
			    //      this.activeAnimal='正常'
			    //    }
                    } else {
                    // this.$message.error(data.message);
                }
            })
        },
        videoshows(){
         this.shows=false
         document.getElementById("video").play();
         document.getElementById("video").addEventListener('pause', ()=> { //暂停开始执行的函数
         this.shows=true
        // 执行暂停的逻辑
    });
        },
        // 鼠标移入全部显示
        mouseover(val){
        //    console.log(val);
         var divs= document.querySelectorAll('.row-item')
        //  console.log(divs[val.rowIndex].childNodes[val.columnIndex].innerText,'sd');
        // var node=divs[val.rowIndex].childNodes[val.columnIndex]
        // node.clientWidth< node.scrollWidth? (node.title=val.ceil):'return'    
        divs = [...divs]
            divs.forEach(item => {
                item.childNodes.forEach(it => {
                    (it.clientWidth < it.scrollWidth ? (it.title = it.innerText) : 'return')
                })
            })
        },

        // imgBtn(val,type){
        //     if(type==0&&!this.show3){
        //     this.shows=false
        //     var img =this.imgList[0]
        //     this.imgList[0]= this.imgList[val]
        //     this.imgList[val]=img
        //      if(val==1){
        //     this.show4=false
        //     this.$nextTick(()=>{
        //      this.show4=true

        //     })
        //     }
        //     if(val==2){
        //     this.show5=false
        //         this.$nextTick(()=>{
        //         this.show5=true
        //     })
        //     }
        //  if(val==3){
        //     this.show6=false
        //         this.$nextTick(()=>{
        //         this.show6=true
        //     })
        //     }
        //       return
        //     }
        // if(type==0&&this.show3){
        //     this.shows=false
        //     var img =this.imgList[0]
        //     this.imgList[0]= this.imgList[val]
        //     this.imgList[val]=img
        //     if(val==1){
        //   // this.show3=false
        //     this.$nextTick(()=>{
        //         this.show4=false
        //         this.show3=false
        //     })
        //     }
        //     if(val==2){
        //         this.$nextTick(()=>{
        //         this.show5=false
        //         this.show3=false
        //     })
        //     }
        //     if(val==3){
        //         this.$nextTick(()=>{
        //         this.show6=false
        //         this.show3=false
        //     })
        //     }
        //   return     
        // }
        // if(type!=0){
        //  this.shows=true
        //      var img =this.imgList[0]
        //     this.imgList[0]= this.imgList[val]
        //     this.imgList[val]=img
        //     if(val==1){
        //         this.$nextTick(()=>{
        //             this.show4=true
        //             this.show3=true
        //         })
        //     }
        //     if(val==2){
        //         this.$nextTick(()=>{
        //             this.show5=true
        //             this.show3=true
        //         })
        //     }
        //     if(val==3){
        //         this.$nextTick(()=>{
        //             this.show6=true
        //             this.show3=true
        //         })
        //     }
        //   return 
        // } 
        imgBtn(val){
             this.show3=false
            var img =this.imgList[0]
            this.imgList[0]= this.imgList[val]
            this.imgList[val]=img
            this.$nextTick(()=>{
             this.show3=true
            })     
        },
           // 获取养殖信息
           breedList(val) {
            this.$http({
                url: 'screenapp-service/screenLiveStock/records',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "pageNum": this.pageNum,
                    "pageSize": this.pageSize,
                    animalId: this.info.animalId,
                    "dataFlag": 1
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    this.immuneRecordData = data.result.immuneRecords&&data.result.immuneRecords.records||[]
                    this.diseaseRecordData = data.result.cureRecords&&data.result.cureRecords.records||[]
                    this.weightRecordData = data.result.weighRecords&&data.result.weighRecords.records||[]
                    this.breedRecordData = data.result.breedRecords&&data.result.breedRecords.records||[]
                    this.quarantineData=data.result.quarantineRecords&&data.result.quarantineRecords.records||[]
                    this.result= data.result
                    this.showList(val)
                } else {
                    // this.$message.error(data.message);
                }
            })
        },
            // 电子围栏查询
           enclosureList(row){
            this.$http({
                url:'screenapp-service/screenElectronicFence/select',
                method: 'post',
                data: {
                    animalId: '2'
                    // animalId: this.info.animalId
                },
            }).then(res => {
                 const data = res.data;
                    if(data.code === 200) {
                 this.path = data.result
                 this.anType = data.result[0].type
                 this.infoMap(data.result)
                    } else {
                    // this.$message.error(data.message);
                }
            })
        },
        // 获取活畜档案
        getassemblyList(){
            this.$http({
                url:'screenapp-service/screenLiveStockRecord/assembly',
                method: 'post',
                data: {
                    // animalId: '1'
                    animalId: this.info.animalId
                },
            }).then(res => {
                 const data = res.data;
                    if(data.code === 200) {
                        this.liveStockLocation=data.result.liveStockLocation
                        this.exerciseDisMap=data.result.exerciseDisMap
                        this.temperatureDisMap=data.result.temperatureDisMap
                        this.todayStepNumber= this.exerciseDisMap.seven.value[this.exerciseDisMap.seven.value.length-1]
                   if(this.todayStepNumber<=6000){
			         this.activeAnimal='懒惰'
			       } else if(this.todayStepNumber>=9000){
			         this.activeAnimal='活跃'
			       } else {
			         this.activeAnimal='正常'
			       }
                        this.serviceStatusBtn(this.serviceStatus)
                        this.statusBtn(this.status)

                //  this.path = data.result.electronicFences
                //  this.anType = data.result.electronicFences[0].type
                //  this.infoMap(data.result.electronicFences)
                    } else {
                    // this.$message.error(data.message);
                }
            })
        },
        infoMap(data) {
            this.map = new BMap.Map('map')
            // 大牛轨迹
            //创建地图
            var array = new Array()
            data.forEach(function(item,) {
                array.push(new BMap.Point(+item.longs, item.lat))
            })
            // console.log(array,'niu')
            this.polygon2 = new BMap.Polygon(array, {
                strokeColor: '#f50704',
                fillColor: '#cfcfcf',
                strokeWeight: 3,
                strokeOpacity: 0,
                fillOpacity: 0,
            })
            // 设置中心点
            var point = new BMap.Point(array[0].lng, array[0].lat,{ mapType: BMAP_SATELLITE_MAP }) // 创建点坐标
            this.point1 = new BMap.Point(array[0].lng, array[0].lat, { mapType: BMAP_SATELLITE_MAP }) // 创建点坐标(接口数据替换)
            // 初始化地图,设置中心点坐标和地图级别
            this.map.centerAndZoom(point, 14)
            // this.map.setMapType(BMAP_HYBRID_MAP);
            this.map.setMapType(BMAP_NORMAL_MAP);

            var myDate = new Date()
            // 获取当前分钟
            var min = myDate.getMinutes()
            myDate.setMinutes(min - 5)
            var opts = {
                position: this.point1, // 指定文本标注所在的地理位置
                offset: new BMap.Size(0, -50), //设置文本偏移量
            }
            var label = new BMap.Label(myDate.toLocaleString(), opts) // 创建文本标注对象
            label.setStyle({
                color: 'red',
                fontSize: '12px',
                height: '20px',
                lineHeight: '20px',
                fontFamily: '微软雅黑',
                border: 'none',
                //background:'rgba(255,255,255,0)'
            })
            var marker = new BMap.Marker(new BMap.Point(array[0].lng, array[0].lat)) // (接口数据替换)
            marker.setAnimation(BMAP_ANIMATION_BOUNCE)
            this.initialize()
        },


        //创建标注点并添加到地图中
        addMarker(points) {
            //循环建立标注点
            for (var i = 0, pointsLen = points.length; i < pointsLen; i++) {
            var marker = new BMap.Marker(points[i]) //将点转化成标注点
            //添加监听事件
            ;(function() {
                var thePoint = points[i]
                marker.addEventListener('click', function() {
                    // showInfo(this, thePoint)
                    console.log(thePoint)
                })
            })()
            }
        },

        initialize() {
            // alert("点击标注点可以显示是否在区域内");
            // 开启百度地图API功能
            this.map.addControl(new BMap.NavigationControl()) // 添加平移缩放控件
            this.map.addControl(new BMap.ScaleControl()) // 添加比例尺控件
            this.map.addControl(new BMap.OverviewMapControl()) //添加缩略地图控件
            // this.map.enableScrollWheelZoom() //启用滚轮放大缩小
            this.map.addControl(new BMap.MapTypeControl()) //添加地图类型控件
            this.addMarker(this.point1)
            this.map.addOverlay(this.polygon2)

            // map1.addControl(new BMap.NavigationControl()) // 添加平移缩放控件
            // map1.addControl(new BMap.ScaleControl()) // 添加比例尺控件
            // map1.addControl(new BMap.OverviewMapControl()) //添加缩略地图控件
            // map1.enableScrollWheelZoom() //启用滚轮放大缩小
            // map1.addControl(new BMap.MapTypeControl()) //添加地图类型控件

            // var point = new BMap.Point(111.709858,40.790287); // 创建点坐标
            // map.centerAndZoom(point, 12); // 初始化地图,设置中心点坐标和地图级别。
            this.pointStart()
            this.addMarker1(new BMap.Point(+this.path[0].longs, +this.path[0].lat), '起点', this.map)
        },
        addMarker1(point, name, mapInit) {
            if (name == '起点') {
            // var myIcon = new BMap.Icon(new BMap.Size(45, 45), {
            //     anchor: new BMap.Size(20, 45),
            // })
            var marker = new BMap.Marker(point); // 创建标注

            // mapInit.addOverlay(marker);               // 将标注添加到地图中
            // marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
            }
        },
        pointStart(){
            var mapIcon = ''
            if (this.anType == 0) {
                mapIcon = this.animalImg
            } else {
                mapIcon = require('../../assets/sheep.jpg')
            }


            // var carMk //先将终点坐标展示的mark对象定义
            var PointArr = this.path
            this.myIcon2 = new BMap.Icon(mapIcon, new BMap.Size(65, 65), {
                anchor: new BMap.Size(30, 30),
            }) //初始化终点坐标图标
            var temporary = []
            var i = 0
            var interval = setInterval(() => {
                if (i >= PointArr.length - 1) {
                clearInterval(interval)
                return false
                }
                i = i + 1
                temporary.push(PointArr[i])
                this.drowLine(this.map, temporary) //画线调用
            }, 500)
        },
        drowLine(map, temporary) {
            if (temporary && temporary.length > 1) {
            //判断数值为两个点时开始进行绘制
            for (var i = 0; i < temporary.length - 1; i++) {
                var polyline22 = new BMap.Polyline([new BMap.Point(+temporary[i].longs, temporary[i].lat), new BMap.Point(+temporary[i + 1].longs, temporary[i + 1].lat)], {
                    strokeColor: 'green',
                    strokeWeight: 7,
                    strokeOpacity: 1,
                }) //创建折线
                map.addOverlay(polyline22)
                this.addMarkerEnd(new BMap.Point(+temporary[i + 1].longs, temporary[i + 1].lat), '终点', map, temporary[i + 1]) //添加图标
            }
            }
        },
        addMarkerEnd(point, name, mapInit, trackUnit) {
            if (name == '终点') {
            if (this.carMk) {
                //先判断第一次进来的时候这个值有没有定义，有的话就清除掉上一次的。然后在进行画图标。第一次进来时候没有定义也就不走这块，直接进行画图标
                mapInit.removeOverlay(this.carMk)
            }
            this.carMk = new BMap.Marker(point, { icon: this.myIcon2 }) // 创建标注
            this.carMk.setRotation(trackUnit.route) //trackUnit.route
            mapInit.addOverlay(this.carMk) // 将标注添加到地图中
                this.carMk.setAnimation(BMAP_ANIMATION_BOUNCE) //跳动的动画
            }
        },
        // 底部
        switchStatusBtn(val) {
             if(val === '3'){
                return
            }
            this.breedList(val)
        },
        showList(val){
            this.isShow = true
             // 获取body元素
        var bodyEle = document.body
        // var footerEle=document.querySelector('.footer')
        // footerEle.style.marginBottom=2+'rem'
        bodyEle.style.position='fixed'
        bodyEle.style.top='0'
        bodyEle.style.height='100%'
        bodyEle.style.overflow='hidden'
            if (val === '0') {
            this.show1 = true
            this.show2=false
            this.switchStatus = '基础信息'
            this.text='基础信息'
            } else {
            this.show1 = false
                this.show2=true
// this.$nextTick(()=>{
//     document.querySelector('.sheet').style.minHeight=6+'rem'

// })
                 if (val === '1') {
            this.switchStatus = '免疫检录'
            this.text='免疫检录'
            this.total= this.result.immuneRecords&&this.result.immuneRecords.total
            var dataArr=[]
            this.immuneRecordData.forEach((item)=>{
                dataArr.push([item.immuneDate,item.projectName,item.dosage,item.inoculationMethod,item.vaccineManufacturers,item.vaccineBatch,
                item.immuneRemark])
            })
            this.config={
                data:dataArr,
                header: ['免疫日期', '疫苗名称', '剂量', '接种方式', '疫苗厂家', '疫苗批次','免疫说明'],
                align: ['left', 'left', 'left', 'left', 'left', 'left', 'left'],
                columnWidth: [200, 290, 200, 200, 260, 200,200,300],
                headerHeight: 40,
                rowNum: 5,
                waitTime: 2000
            }
            } 
            if (val === '2') {
            this.switchStatus = '检疫记录'
            this.text = '检疫记录'
            var dataArr=[]
            this.quarantineData.forEach((item)=>{
                dataArr.push([item.quarantineDate,item.quarantineProject,item.quarantineMethod,
                item.quarantineRemark,])
                // dataArr.push([item.quarantineDate,item.quarantineProject,item.quarantineMethod,item.quarantineOrgan,item.quarantineResult,
                // item.operator,item.quarantineRemark,])
            })
            this.config={
                data:dataArr,
                header: ['检疫日期', '检疫项目', '检疫方式','检疫说明'],
                align: ['left', 'left', 'left', 'left'],
                // header: ['检疫日期', '检疫项目', '检疫方式', '检疫机构', '检疫结果','操作人员','检疫说明'],
                // align: ['left', 'left', 'left', 'left', 'left', 'left', 'left'],
                headerHeight: 40,
                 rowNum: 5,
                waitTime: 2000
            }

            } 
              if (val === '4') {
            this.switchStatus = '称重记录'
            this.text = '称重记录'
            this.total= this.result.weighRecords&&this.result.weighRecords.total
            var dataArr=[]
            this.weightRecordData.forEach((item)=>{
                dataArr.push([item.weighDate,item.currentWeight,item.lastWeight,item.growingWeight])
            })
            this.config={
                data:dataArr,
                header: ['称重日期', '本次称重重量', '上次称重重量', '比上次增重'],
                align: ['left', 'left', 'left', 'left'],
                // columnWidth: [200, 200, 200, 150, 50, 200, 100],
                headerHeight: 40,
                rowNum: 5,
                waitTime: 2000
            }

            } 
              if (val === '5') {
            this.switchStatus = '疾病治疗记录'
            this.text = '疾病治疗记录'
            this.total= this.result.cureRecords&&this.result.cureRecords.total
            var dataArr=[]
            this.$nextTick(()=>{
                document.querySelector('.dialog_ .text').style.left=6.9+'rem'
            })
            this.diseaseRecordData.forEach((item)=>{
                dataArr.push([item.cureDate,item.cureType,item.symptom,item.curePlan,item.veterinaryName,item.cureResult])
            })
            this.config={
                data:dataArr,
                header: ['治病日期', '治病类型', '症状及并发症', '治疗方法', '兽医姓名', '治疗结果'],
                align: ['left', 'left', 'left', 'left', 'left', 'left'],
                columnWidth: [150, 150, 300, 300, 150, 200],
                headerHeight: 40,
                 rowNum: 5,
                waitTime: 2000
            }
            } 
              if (val === '6') {
            this.switchStatus = '繁育记录'
            this.text = '繁育记录'
            this.total= this.result.breedRecords&&this.result.breedRecords.total
            var dataArr=[]
            this.breedRecordData.forEach((item)=>{
                dataArr.push([item.mattingDate,item.mattingPeople,
                item.childbirthDate,item.deliveryResult,item.calfNumber,item.breedInstruction])
                // dataArr.push([item.barrenDay,item.mattingDate,item.mattingPeopleNumber,item.mattingPeople,item.pregnancyDays,
                // item.childbirthDate,item.deliveryResult,item.deliveryMode,item.calvingCount,item.calvingInterval,item.breedInstruction])
            })
            this.config={
                data:dataArr,
                header: ['配种日期','配种员', '分娩日期', '分娩结果','产犊数量','繁育说明'],
                align: ['left', 'left', 'left', 'left', 'left', 'left'],
                columnWidth: [200,200, 200, 400, 200, 400],
                // header: ['空怀天数', '配种日期', '配种对象编号', '配种员', '妊娠天数', '分娩日期', '分娩结果','分娩方式','产犊数量','产犊间隔','繁育说明'],
                // align: ['right', 'left', 'left', 'left', 'right', 'left', 'left','left', 'right', 'right', 'left'],
                // columnWidth: [200, 200, 300,200, 200, 200, 200, 200, 200, 200, 200],
                headerHeight: 40,
                rowNum: 5,
                waitTime: 2000
            }
            } 
            }
            var footerItem=this.footerList[3]
            this.footerList[3]=this.footerList[val]
            this.footerList[val]=footerItem
            this.imgfile[val].show= false
            this.imgfile[3].show= false
                this.$nextTick(()=>{
            this.imgfile[val].img= this.imgfile_[3]
            this.imgfile[3].img= this.imgfile_[val]
            this.imgfile[val].show= true
            this.imgfile[3].show= true
            })
        },
        btnClick(val){
              // 翻页
            if (val === 'left') {
                if (this.hasPreviousPage) {
                    this.numStatus = 'left'
                    this.pageNum--
                    // this.getBreederList()
                } else {
                    this.numStatus = 'right'
                }
            }
            if (val === 'right') {
                if (this.hasNextPage) {
                    this.numStatus = 'right'
                    this.pageNum++
                    // this.getBreederList()
                } else {
                    this.numStatus = 'left'
                }
            }

            // if(val==='left'){
            //  this.numStatus='left'
            // }
            // if(val==='right'){
            //  this.numStatus='right'
            // }
        },
        // 弹出框关闭
        closeIcon() {
            var bodyEle = document.body
            // var footerEle=document.querySelector('.footer')
            // footerEle.style.marginBottom=''
            bodyEle.style.position=''
            bodyEle.style.top=''
            bodyEle.style.height=''
            bodyEle.style.overflow=''
            this.switchStatus = '活畜动态'
            this.footerList=['基础信息','免疫检录','检疫记录','活畜动态','称重记录','疾病治疗记录','繁育记录']
            this.isShow = false
                this.$nextTick(()=>{
                    this.imgfile=[{img:require("../../assets/file1.png"),show:true},{img:require("../../assets/file2.png"),show:true},{img:require("../../assets/file3.png"),show:true},
            {img:require("../../assets/file4.png"),show:true},{img:require("../../assets/file5.png"),show:true},{img:require("../../assets/file6.png"),show:true},{img:require("../../assets/file7.png"),show:true}
        ]//左右不带下标的切换图
            })
        },
        // 返回上一层
        goBack() {
            this.$router.go(-1)
        },
        // 运动量分布切换
        serviceStatusBtn(val) {
            if (val === 'first') {
                this.serviceStatus = 'first'
                this.data_Sport = this.exerciseDisMap.seven
				// this.todayStepNumber= this.data_Sport.value[this.data_Sport.value.length-1]
            }
            if (val === 'three') {
                this.serviceStatus = 'three'
                this.data_Sport = this.exerciseDisMap.fifteen
            }
            if (val === 'six') {
                this.serviceStatus = 'six'
                this.data_Sport = this.exerciseDisMap.thirty
            }
            // if(this.todayStepNumber<=6000){
			//     this.activeAnimal='懒惰'
			// } else if(this.todayStepNumber>=9000){
			//     this.activeAnimal='活跃'
			// } else {
			//     this.activeAnimal='正常'
			// }
            this.lineData = []
            this.lineData.push({ title: '运动量', value: this.data_Sport.value, month: this.data_Sport.label })
            this.setLineData(this.lineData, 'lineChart')
        },
        // 体温切换
        statusBtn(val) {
            if (val === 'first_') {
                this.status = 'first_'
                this.temperaItem = this.temperatureDisMap.seven
            }
            if (val === 'three_') {
                this.status = 'three_'
                this.temperaItem = this.temperatureDisMap.fifteen
            }
            if (val === 'six_') {
                this.status = 'six_'
                this.temperaItem = this.temperatureDisMap.thirty
            }
            this.temperaData=[]
            this.temperaData.push({ title: '体温', value: this.temperaItem.value, month: this.temperaItem.label })
            this.setLineData(this.temperaData, 'lineChart2')
        },
        // 设置折线图
        setLineData(data, dom) {
            const colors = ['#1EE7E7', '#0EDAE2', '#5931FC'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#FFFFFF' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.month,
                name=item.title,
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                name,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "8%",
                    right: "3%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            this.chart = this.$echarts.init(document.getElementById(data.dom))
            if(data.name==='体温'){
            this.lang=[3,40,0,0]
            } else {
            this.lang=[3,50,0,0]
            }
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                            }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${data.dom==='lineChart'?params[0].value + '步':params[0].value + '℃'
                            }</p>
                         `;
                        // return params.name
                    },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                // legend: data.legend,
                grid: {
                    // top: '20%',
                    left: '8%',
                    right: '4%',
                    bottom: '10%',
                    // height:'120px',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: data.name,
                    nameTextStyle: {
                        color: '#FFFFFF',
                        // padding: [3, 4],
                        padding: this.lang,
                        lineHeight: 60,
                        // verticalAlign:'bottom'
                        // align:'center'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 4,
                    axisLine: { 
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            this.chart.clear();
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        position: relative;

        .gobcak {
            width: .875rem;
            height: .4375rem;
            position: absolute;
            z-index: 99;
            bottom: -0.25rem;
            left: 0.25rem;
            font-size: .2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }

    .content {
        padding: .29rem .25rem 0 .25rem;
        box-sizing: border-box;
        background: url('../../assets/bg_archives.png');
        // background: url('../../assets/video_bg_1.mp4');
        background-size: 100% 100%;
        display: flex;
        min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);
        position: relative;

        .left {
            .top {
                width: 6.25rem;
                height: 5.75rem;
                background: linear-gradient(119deg, rgba(0, 222, 217, 0.1) 19%, rgba(0, 223, 218, 0) 72%);
                border-left: 0.01rem solid rgba(0, 224, 219, 0.3);

                .line_chart {
                    width: 100%;
                    // height: 4.5rem;
                    height: 3.7rem;
                    margin-top: .5rem;
                }
            }

            .bottom {
                width: 6.25rem;
                height: 5rem;
                background: linear-gradient(66deg, rgba(0, 222, 217, 0.1) 0%, rgba(0, 223, 218, 0) 70%);
                border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
                margin-top: .25rem;
            }
        }

        .center {
            flex: 1;
            // width: 8.85rem;
            // height: 8.61rem;
            height: 11.4rem;
            margin: 0 .7rem;
            // margin: 0 .81rem;
            position: relative;

            .center_top {
                width: 100%;
                display: flex;

                .top_item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-left: .13rem;

                    span {
                        font-size: 0.18rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                        padding-bottom: .08rem;
                    }

                    .small_big {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        // width: 2.25rem;
                        width: 1.8rem;
                        height: 0.75rem;
                        background: rgba(0, 223, 218, 0.08);
                        opacity: 1;
                        font-size: 0.25rem;
                        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                        font-weight: bold;
                        color: #00E0DB;
                        position: relative;

                        &::after {
                            position: absolute;
                            left: 0;
                            top: 0;
                            content: "";
                            width: 0.13rem;
                            height: 0.13rem;
                            opacity: 1;
                            border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
                            border-top: 0.01rem solid rgba(0, 224, 219, 0.3);
                        }

                        &::before {
                            position: absolute;
                            right: 0;
                            top: 0;
                            content: "";
                            width: 0.13rem;
                            height: 0.13rem;
                            opacity: 1;
                            border-top: 0.01rem solid rgba(0, 224, 219, 0.3);
                            border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
                        }

                        .top_box {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: .3rem;

                            &::after {
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                content: "";
                                width: 0.13rem;
                                height: 0.13rem;
                                opacity: 1;
                                border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
                                border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
                            }

                            &::before {
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                content: "";
                                width: 0.13rem;
                                height: 0.13rem;
                                opacity: 1;
                                border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
                                border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
                            }
                        }
                    }

                    .small_big_state {
                        color: #00ff44;
                    }

                    .state {
                        color: #ff9900;
                    }
                }
            }

            .center_box {
                width: 100%;
                height: 6.84rem;
                margin-top: .73rem;
                padding: 0 .26rem;
                position: relative;

                .zhan {
                    height: 2.95rem;
                }

                .turn {
                    height: 3.84rem;

                    .turn_item {
                        width: 6.85rem;
                        height: 2.34rem;
                        margin: 1.16rem 1rem .34rem 1rem;
                        // background: url('../../assets/turn.png');
                        // background-size: 100% 100%;
                    }
                }

                .heart_line {
                    position: absolute;
                    top: .86rem;
                    left: 2.95rem;
                    width: .2rem;
                    height: 1.34rem;
                    opacity: 1;
                    border-left: 0.01rem solid rgba(0, 222, 218, 0.15);

                    &::after {
                        position: absolute;
                        left: -0.065rem;
                        top: -0.065rem;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        background: #012D40;
                        ;
                        opacity: 1;
                        border-radius: 50%;
                    }

                }

                .tempera {
                    position: absolute;
                    top: .96rem;
                    left: 4.84rem;
                    width: 1.1rem;
                    height: 1.4rem;
                    opacity: 1;
                    border-left: 0.01rem solid rgba(0, 222, 218, 0.15);
                    border-top: 0.01rem solid rgba(0, 223, 218, 0.15);


                    &::after {
                        position: absolute;
                        right: -0.065rem;
                        top: -0.065rem;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        background: #012D40;
                        ;
                        opacity: 1;
                        border-radius: 50%;
                    }
                }

                .rate {
                    position: absolute;
                    top: 4.7rem;
                    left: 1.1rem;
                    width: 2.2rem;
                    height: 0rem;
                    opacity: 1;
                    border: 0.01rem solid rgba(0, 223, 218, 0.15);


                    &::after {
                        position: absolute;
                        left: -0.065rem;
                        top: -0.065rem;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        background: #012D40;
                        ;
                        opacity: 1;
                        border-radius: 50%;
                    }
                }

                .active_ {
                    position: absolute;
                    top: 3.8rem;
                    left: 5.74rem;
                    width: 1.4rem;
                    height: 0rem;
                    opacity: 1;
                    border: 0.01rem solid rgba(0, 224, 219, 0.149);

                    &::after {
                        position: absolute;
                        right: -0.065rem;
                        top: -0.065rem;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        background: #012D40;
                        ;
                        opacity: 1;
                        border-radius: 50%;
                    }
                }

                .animal {
                    width: 6.46rem;
                    height: 5.35rem;
                    position: absolute;
                    top: 0.61rem;
                    left: .55rem;
                    background: url('../../assets/g.png');
                    background-size: 100% 100%;
                    background-position: .1rem .44rem;
                }

                .heart {
                    display: flex;
                    position: absolute;
                    height: 0.73rem;

                    img {
                        width: 0.78rem;
                    }

                    .heart_r {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        font-size: 0.45rem;
                        font-family: 汉仪菱心体简-regular, 汉仪菱心体简;
                        font-weight: 400;
                        color: #FFE11D;
                        margin-left: .1rem;

                        span:nth-child(2) {
                            font-size: 0.18rem;
                            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                            font-weight: 400;
                            color: #E1E3EF;
                        }

                        .heart_item {
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN !important;
                        }
                    }




                }

                .heart_ {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    height: 1.76rem;

                    .heart_r {
                        display: flex;
                        flex-direction: column;

                        span:nth-child(1) {
                            padding-top: .23rem;
                        }

                        span:nth-child(2) {
                            padding-top: .3rem;
                        }
                    }

                }
            }
        }

        .right {
            .top {
                width: 6.25rem;
                height: 5.75rem;
                background: linear-gradient(75deg, rgba(0, 223, 218, 0) 25%, rgba(0, 222, 217, 0.1) 100%);
                border-right: 0.01rem solid rgba(0, 224, 219, 0.3);


                .line_chart2 {
                    width: 100%;
                    // height: 4.5rem;
                    height: 3.7rem;
                    margin-top: .5rem;
                }
            }

            .bottom {
                width: 6.25rem;
                height: 5rem;
                background: linear-gradient(291deg, rgba(0, 222, 217, 0.1) 8%, rgba(0, 223, 218, 0) 70%);
                border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
                margin-top: .25rem;
            }
        }

        .footer {
            position: absolute;
            bottom: 0;
            left: -6.25rem;
            width: 22.08rem;
            height: 2.8rem;
            display: flex;
            justify-content: center;

            .switch {
                font-size: 0.23rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                display: flex;
                flex-direction: column;
                justify-content: inherit;
                align-items: center;
                margin-left: .6rem;
                cursor: pointer;
                // opacity: .7;
                opacity: 1;

                span {
                    padding-top: .25rem;
                }
            }

            .switch:nth-child(1) {
                margin-left: 0;
                // transform: translate(0, 1.2rem);
                margin-top: 2.3rem;
            }

            .switch:nth-child(2) {
                // transform: translate(0, 1.05rem);
                margin-top: 2.1rem;
            }

            .switch:nth-child(3) {
                // transform: translate(0, .95rem);
                margin-top: 1.9rem;

            }

            .switch:nth-child(4) {
                // transform: translate(0, .7rem);
                margin-top: 1.4rem;
            }

            .switch:nth-child(5) {
                // transform: translate(0, .95rem);
                margin-top: 1.9rem;

            }

            .switch:nth-child(6) {
                // transform: translate(0, 1.05rem);
                margin-top: 2.1rem;
            }

            .switch:nth-child(7) {
                // transform: translate(0, 1.2rem);
                margin-top: 2.3rem;


            }
        }
    }

    .video_box {
        position: relative;
        // width: 7.63rem;
        width: 5.75rem;
        height: 4rem;
        padding: .2rem;
        margin: .25rem;
        border: 0.01rem solid rgba(0, 224, 219, 0.08);
        z-index: 100;

        &::after {
            position: absolute;
            left: 0;
            top: 0;
            content: "";
            width: .18rem;
            height: .14rem;
            border-left: 1px solid #00E0DB;
            border-top: 1px solid #00E0DB;
        }

        &::before {
            position: absolute;
            right: 0;
            top: 0;
            content: "";
            width: .18rem;
            height: .14rem;
            border-right: 1px solid #00E0DB;
            border-top: 1px solid #00E0DB;
        }

        .top_box {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1rem;

            &::after {
                position: absolute;
                left: 0;
                bottom: 0;
                content: "";
                width: .18rem;
                height: .14rem;
                border-left: 1px solid #00E0DB;
                ;
                border-bottom: 1px solid #00E0DB;
                ;

            }

            &::before {
                position: absolute;
                right: 0;
                bottom: 0;
                content: "";
                width: .18rem;
                height: .14rem;
                border-right: 1px solid #00E0DB;
                ;
                border-bottom: 1px solid #00E0DB;
                ;

            }
        }

        .device_box {
            // width: 7.23rem;
            width: 5.35rem;
            height: 3.6rem;
            display: flex;
            justify-content: center;
            align-items: center;

            // background-color: red;
            .map {
                width: 100%;
                height: 100%;
            }

            .map_main {
                width: 100%;
                height: 100%;
            }
        }
    }

    .server {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        background: linear-gradient(119deg, rgba(0, 222, 217, 0.3) 19%, rgba(0, 223, 218, 0) 88%);

        // padding-top: .24rem;
        .card_ {
            font-size: 0.23rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #00E0DB;
            padding-left: .25rem;
        }

        .date {
            // margin-left: 1.2rem;
            color: #7B8A89;
            padding-right: 0.15rem;

            span {
                padding: .03rem .05rem;
                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                background: rgba(255, 255, 255, 0.05);
                opacity: .5;
                font-weight: 400;
                cursor: pointer;
            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }

    .active {
        background: rgba(255, 255, 255, 0.2) !important;
        // opacity: 1;
        color: #00E0DB !important;
        opacity: 1 !important;
    }

    .sport {
        display: flex;
        flex-direction: column;
        font-size: 0.38rem;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: bold;
        color: #00E0DB;
        margin-top: .44rem;
        margin-left: .5rem;

        span:nth-child(2) {
            font-size: 0.15rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: .2rem;
        }
    }

    @keyframes warn {
        0% {
            transform: scale(0);
            opacity: 0.0;
        }

        25% {
            transform: scale(0);
            opacity: 0.45;
        }

        50% {
            transform: scale(0.1);
            opacity: 0.65;
        }

        75% {
            transform: scale(0.5);
            opacity: 0.85;
        }

        100% {
            transform: scale(1);
            opacity: 0.0;
        }
    }

    .big_box {
        position: absolute;
        width: 0.24rem;
        height: 0.24rem;
        // background: rgba(0, 255, 255, 0);
        // opacity: 1;
        border: 0.1rem solid rgba(255, 255, 255, 1);
        border-radius: 50%;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        z-index: 1;
        opacity: 0;
        -webkit-animation: warn 3s ease-out;
        -moz-animation: warn 3s ease-out;
        animation: warn 3s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;

        .center_box1 {
            width: 0.16rem;
            height: 0.16rem;
            // background: rgba(0, 255, 255, 0);
            // opacity: 1;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            z-index: 1;
            opacity: 0;
            -webkit-animation: warn 3s ease-out;
            -moz-animation: warn 3s ease-out;
            animation: warn 3s ease-out;
            -webkit-animation-iteration-count: infinite;
            -moz-animation-iteration-count: infinite;
            animation-iteration-count: infinite;
            border: 0.1rem solid rgba(255, 255, 255, 1);
            border-radius: 50%;
            margin: auto;
            margin-top: .025rem;

            .small_box {
                width: 0.06rem;
                height: 0.06rem;
                background: rgba(255, 255, 255, 1);
                opacity: 0;
                -webkit-animation: warn 3s ease-out;
                -moz-animation: warn 3s ease-out;
                animation: warn 3s ease-out;
                -webkit-animation-iteration-count: infinite;
                -moz-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
                border-radius: 50%;
                padding: .03rem;
                margin: auto;
                margin-top: .03rem;
            }
        }
    }

    /* 产生动画（向外扩散变大）的圆圈  */
    // .pulse {
    //     position: absolute;
    //     width: 24px;
    //     height: 24px;
    //     left: 2px;
    //     top: 2px;
    //     border: 6px solid red;
    //     -webkit-border-radius: 30px;
    //     -moz-border-radius: 30px;
    //     border-radius: 30px;
    //     z-index: 1;
    //     opacity: 0;
    //     -webkit-animation: warn 3s ease-out;
    //     -moz-animation: warn 3s ease-out;
    //     animation: warn 3s ease-out;
    //     -webkit-animation-iteration-count: infinite;
    //     -moz-animation-iteration-count: infinite;
    //     animation-iteration-count: infinite;
    // }

    .active1 {
        color: #11F3D6 !important;
        opacity: 1 !important;
        z-index: 99999;
    }

    .box_ {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .8);
        z-index: 9999;

    }

    .num_change {
        color: #FFFFFF !important;
    }

    .dialog_ {
        // margin-top: -2.5rem;
        min-width: 15.79rem;
        min-height: 3.77rem;
        position: relative;
        background: url('../../assets/低.png');
        background-size: 100% 100%;

        .text {
            font-size: 0.3rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #032929;
            position: absolute;
            top: 0.3rem;
            left: 7.2rem;
        }

        .close_icon {
            position: absolute;
            top: .25rem;
            right: .38rem;
            color: #00e0db;
            font-size: .3rem;
            cursor: pointer;
        }

        .num {
            font-size: 0.13rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            justify-content: flex-end;
            margin: 0 .38rem 0.26rem 0;

            span {
                color: #7B8A8A;
                font-size: 0.18rem;
                font-weight: 700;
                margin-left: .21rem;
                cursor: pointer;
            }
        }

    }

    .dialog {
        // margin-top: -2.5rem;
        min-width: 8.79rem;
        min-height: 5.81rem;
        position: relative;
        background: url('../../assets/info.png');
        background-size: 100% 100%;

        .text {
            font-size: 0.3rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #032929;
            position: absolute;
            top: 0.25rem;
            left: 3.8rem;
        }

        .close_icon {
            position: absolute;
            top: .25rem;
            right: .38rem;
            color: #00e0db;
            font-size: .3rem;
            cursor: pointer;
        }

        .picture {
            display: flex;
            margin-top: 1.22rem;
            margin-left: .5rem;

            .p_left {
                width: 3rem;
                height: 4.1rem;

                img {
                    width: 100%;
                    height: 3rem;
                    border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
                    cursor: pointer;

                }

                .img {
                    display: flex;
                    margin-top: .18rem;

                    img {
                        width: .88rem;
                        height: .88rem;
                        border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
                        cursor: pointer;

                    }

                    img:nth-child(2) {
                        margin: 0 .18rem;
                    }
                }
            }

            .p_right {
                flex: 1;
                height: 4.1rem;
                margin-left: .63rem;
                display: flex;
                // justify-content: space-around;

                .info_1 {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    // align-items: center;
                    font-size: 0.2rem;
                    font-family: PingFang SC-中等, PingFang SC;
                    font-weight: normal;
                    color: #0DD3DD;
                }

                .info_ {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    // align-items: center;
                    font-size: 0.2rem;
                    font-family: PingFang SC-中等, PingFang SC;
                    font-weight: normal;
                    color: #FFFFFF;
                    margin-left: .34rem;
                }

            }
        }

    }

    .fillWidth {
        width: 100%;
        height: 100%;
        object-fit: fill;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -99;
    }
}
</style>
<style lang="scss">
.archives {
    .active-ring-name {
        padding-top: .1rem;
    }

    .el-input__inner {
        width: 1.25rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08);
        border: none;
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        border: 0.01rem solid rgba(0, 223, 218, 0.4);
    }

    .search_input.el-input .el-input__inner {
        width: 2.25rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: .33rem;

    }

    .search_input>.el-input__inner {
        padding: 0 0 0 .4rem;
    }

    // DataV
    .header {
        background: rgba(0, 224, 219, 0.08) !important;
        color: #00E0DB !important;

    }

    // DataV
    .header-item {
        opacity: .85;
    }

    .rows {
        min-height: 2rem !important;
        padding: .2rem 0 .4rem 0;
    }

    .row-item {
        background: transparent !important;
        font-size: .15rem !important;
        height: 0.44rem !important;
        line-height: .44rem !important;
        // div:nth-child(7) {
        //     span {
        //         margin-left: .6rem !important;
        //     }
        // }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    // .ceil:hover {
    //     text-overflow: inherit;
    //     overflow: visible;
    //     white-space: pre-line;
    // }
}
</style>